/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import React from "react";
import { Loader } from "semantic-ui-react";

const Index = (props) => (
    <div style={{ paddingTop: "max(20px, 20%)" }}>
        <Loader active inline="centered" {...props}>
            Loading...
        </Loader>
    </div>
);

export default Index;
